import React from 'react';
import styles from './index.module.less';
import classNames from 'classnames';
import poster from '@/public/images/homepage-poster.png';
import Header from 'components/Header';
import JOINUS from '@/public/images/JOINUS.png';
import Image from 'next/image';
import Icon from 'components/Icon';

const HomePage: React.FC = () => {
  return (
    <div className={classNames([styles.mj_homePage_container])}>
      <Header />
      <div className={styles.mj_homePage_video_body}>
        <video
          poster={poster.src}
          className={styles.mj_homePage_video}
          muted
          preload="auto"
          autoPlay
          loop>
          <source src={`/video/homepage.mp4`} />
        </video>
      </div>
      <div className={styles.mj_homePage_content}>
        <div className={styles.mj_homePage_title}>MANJUU GAMES</div>
        <div className={styles.mj_homePage_subTitle}>加入我们</div>
        <Image src={JOINUS} alt="JOIN US" width={261} height={81}></Image>
        <div
          onClick={() => {
            location.href =
              'https://ooia5293gn.jobs.feishu.cn/index/position/list';
          }}
          className={classNames([
            styles.aboutUs_link,
            styles.aboutUs_link_btn,
          ])}>
          <div className={styles.aboutUs_link_content}>
            <div
              className={classNames([
                styles.aboutUs_link_dot,
                styles.aboutUs_link_dot_left,
              ])}
            />
            立即投递
            <div
              className={classNames([
                styles.aboutUs_link_dot,
                styles.aboutUs_link_dot_right,
              ])}></div>
            <div className={styles.aboutUs_link_subtitle}>Manjuu Games</div>
            <Icon
              className={styles.aboutUs_link_right_arrow}
              color="#fff"
              fontClass="ICON-28"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
